import { type FieldProps } from "react-admin";

import { useTypedFieldValue } from "@/hooks";

import { formatDateToStandard } from "./utils/formatDateToStandard";

export const DateFieldWithStandardFormat = <
  RecordType extends Record<string, unknown>,
>(
  props: FieldProps<RecordType>,
) => {
  const value = useTypedFieldValue<string | Date | null, RecordType>(props);

  if (!value) {
    return null;
  }

  const formattedDate = formatDateToStandard(
    value instanceof Date ? value.toISOString() : value,
  );

  return formattedDate;
};
